import React, { useMemo } from 'react';
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { useDashboard } from '../../../contexts/DashboardContext';

export default function DashboardList({ panelId, outputKey = 'list_data', config }) {
  const { getSlice } = useDashboard();
  const raw = getSlice(panelId, outputKey);

  const items = useMemo(() => {
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : raw?.items ?? [];
    return arr.map((item, i) => ({
      id: item.id ?? item._id ?? i,
      title: item.title ?? item.name ?? '',
      subtitle: item.subtitle ?? item.description ?? '',
      icon: item.icon ?? null,
    }));
  }, [raw]);

  if (!items.length) {
    return (
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 120 }}>
        <Typography color="text.secondary">No list data. Use chat or refresh to run a flow.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      <List disablePadding>
        {items.map((item) => (
          <ListItem key={item.id} divider>
            {item.icon && (
              <ListItemIcon sx={{ minWidth: 36 }}>
                {typeof item.icon === 'string' ? (
                  <Typography variant="body2" color="primary">{item.icon}</Typography>
                ) : (
                  item.icon
                )}
              </ListItemIcon>
            )}
            <ListItemText
              primary={item.title}
              secondary={item.subtitle || null}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
